import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const TEAM_COLORS = [
    '#4e79a7', '#f28e2b', '#e15759', '#76b7b2',
    '#59a14f', '#edc948', '#b07aa1', '#ff9da7',
    '#9c755f', '#bab0ac', '#86bcb6', '#8cd17d',
    '#b6992d', '#499894', '#d37295', '#a0cbe8',
];

/**
 * Pie chart component supporting both simple 2-slice and multi-team modes.
 *
 * Simple mode: <PieChart data={[75, 25]} />
 * Team mode:   <PieChart labels={['Team A', 'Team B']} data={[500, 300]} />
 */
const PieChart = ({ data, labels, title }) => {
    const isTeamMode = labels && labels.length > 0;

    const chartData = isTeamMode
        ? {
            labels,
            datasets: [{
                data,
                backgroundColor: TEAM_COLORS.slice(0, labels.length),
                hoverBackgroundColor: TEAM_COLORS.slice(0, labels.length).map(c => c + 'cc'),
            }],
        }
        : {
            labels: ['Completed', 'Remaining'],
            datasets: [{
                data,
                backgroundColor: ['#4caf50', '#cfd8dc'],
                hoverBackgroundColor: ['#66bb6a', '#b0bec5'],
            }],
        };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: isTeamMode ? 'bottom' : 'right',
                labels: {
                    boxWidth: 12,
                    font: { size: 11 },
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const value = context.parsed;
                        const pct = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                        return `${context.label}: ${value.toLocaleString()} (${pct}%)`;
                    },
                },
            },
            datalabels: isTeamMode ? {
                color: '#fff',
                font: { weight: 'bold', size: 11 },
                textAlign: 'center',
                formatter: (value, context) => {
                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                    const pct = total > 0 ? ((value / total) * 100).toFixed(0) : 0;
                    if (pct < 5) return '';
                    const label = context.chart.data.labels[context.dataIndex];
                    return `${label}\n${pct}%`;
                },
                display: (context) => {
                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                    const value = context.dataset.data[context.dataIndex];
                    return total > 0 && (value / total) >= 0.05;
                },
            } : { display: false },
        },
    };

    return (
        <div style={{ height: '250px', width: '100%', margin: '0 auto' }}>
            {title && <h4 style={{ textAlign: 'center', margin: '0 0 8px 0', fontSize: '14px', color: '#333' }}>{title}</h4>}
            <Pie data={chartData} options={options} />
        </div>
    );
};

export { TEAM_COLORS };
export default PieChart;
